export const TitleValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.Title.trim()) {
      errors.Title = 'Title is required';
    } 
  
    return errors;
  };
  
 